/**
 * APP — router + AppLayout shell.
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MbmProvider } from '@amzn/react-arb-tools';
import AppLayout from '@amzn/awsui-components-core/app-layout';
import arbManifest from 'translations/arbManifest';
import { WbrMetricsDashboard } from './dashboard';
import { ExecutionMetricsDashboard } from 'src/pages/ExecutionMetricsDashboard';
import { ExecutiveSummaryPage } from 'src/pages/ExecutiveSummaryPage';
import { PageFooter } from './layout/PageFooter';
import { getMbmOptions } from '../helpers';
import { MONS_ROUTE_BASE } from '../constants';
import './App.scss';
import './dashboard/dashboard.scss';

const mbmOptions = getMbmOptions(arbManifest);

// Behind Mons the app is served under the Monster route path; standalone
// (local dev server) serves at the domain root.
const IS_BEHIND_MONS = !SERVER_MODE || SERVER_MODE === 'mons';
const routerBasename = IS_BEHIND_MONS ? MONS_ROUTE_BASE : '';

const routerFutureFlags = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};

const AppContent = () => {
  return (
    <AppLayout
      content={
        <div className="app-content">
          <Routes>
            <Route path="/" element={<WbrMetricsDashboard />} />
            <Route path="/detail" element={<ExecutionMetricsDashboard />} />
            <Route path="/detail/:networkId" element={<ExecutionMetricsDashboard />} />
            <Route path="/metrics" element={<ExecutiveSummaryPage />} />
            <Route path="/network/:networkId" element={<ExecutiveSummaryPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <PageFooter />
        </div>
      }
      navigationHide={true}
      toolsHide={true}
      contentType="default"
    />
  );
};

const App = () => {
  return (
    <MbmProvider {...mbmOptions}>
      <BrowserRouter basename={routerBasename} future={routerFutureFlags}>
        <AppContent />
      </BrowserRouter>
    </MbmProvider>
  );
};

export default App;
